import type { ReactNode } from "react";

// Use the shared Staff amber waiting pill and keep late reporting secondary.
export default function StaffAttendanceStatus({pending,late,rtl,children,review}:{pending?:boolean;late?:boolean;rtl:boolean;children:ReactNode;review?:ReactNode}){
  return <span className="staff-attendance-status">
    <span className="staff-attendance-status-main">{pending?<span className="pill wt">{rtl?"في انتظار القرار":"Waiting for a decision"}</span>:children}
    {late&&<span className="staff-attendance-late-tag">{rtl?"أبلغنا متأخرًا":"Told us late"}</span>}</span>
    {review}
  </span>;
}
